import styled, { css } from 'styled-components';

import { StyledRepositoryItemActions } from '../RepositoryItemActions/StyledRepositoryItemActions';

const getPointer = ({ isDragging, draggable }) => {
  if (!draggable) return 'pointer';

  if (!isDragging) return 'grab';

  return 'grabbing';
};

const getDisabledStatus = ({ disabled }) => {
  if (!disabled) return null;

  return css`
    position: relative;
    pointer-events: none;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: ${props => props.theme.colors.light};
      opacity: 0.7;
      z-index: 1;
    }
  `;
};

const StyledRepositoryItem = styled.div`
  border-bottom: 2px solid ${props => props.theme.colors.light_darker_1};

  position: relative;

  &:hover,
  &:active {
    background-color: ${props => props.theme.colors.light_dark};
  }

  user-select: none;

  ${StyledRepositoryItemActions} {
    ${props => `visibility: ${props.isTemporary ? 'hidden' : 'visible'}`};
    opacity: 1;
    .hx-repository-item__more-actions {
      visibility: hidden;
      opacity: 0;
    }
  }
  &:hover {
    ${StyledRepositoryItemActions} {
      visibility: visible;
      background-color: ${props => props.theme.colors.light_dark};

      .hx-repository-item__more-actions {
        visibility: visible;
        opacity: 1;
        z-index: 99999;
      }
    }
  }
  ${getDisabledStatus}
`;

const StyledRepositoryItemDraggable = styled.div`
  padding: 0 ${props => props.theme.spacing.small};
  padding-right: 64px;
  border-right: ${props =>
    props.isDragging ? `3px solid ${props.theme.colors.secondary}` : 'none'};
  cursor: ${getPointer};
  width: 100%;
`;

const StyledRepositoryItemClickArea = styled.div`
  padding: ${props => props.theme.spacing.medium} 0;
`;

const statusColor = status => {
  const mapColors = {
    ready: '#4CD964',
    matching: '#FFCC00',
    error: '#FF3B30',
  };
  return mapColors[status] || '#D6D6D6';
};

const StyledRepositoryItemStatus = styled.div`
  border-radius: 50%;
  width: 12px;
  height: 12px;
  background-color: ${props => statusColor(props.status)};
`;

const StyledRepositoryItemStatusDots = styled.div`
  padding-left: 20px;
  .dots {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ffcc00;
    color: #ffcc00;
    animation: dots 1s infinite linear alternate;
    animation-delay: 0.5s;
  }
  .dots::before,
  .dots::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }
  .dots::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ffcc00;
    color: #ffcc00;
    animation: dots 1s infinite alternate;
    animation-delay: 0s;
  }
  .dots::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ffcc00;
    color: #ffcc00;
    animation: dots 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dots {
    0% {
      background-color: #ffcc00;
    }
    50%,
    100% {
      background-color: rgba(255, 204, 0, 0.2);
    }
  }
`;

export {
  StyledRepositoryItemDraggable,
  StyledRepositoryItem,
  StyledRepositoryItemClickArea,
  StyledRepositoryItemStatus,
  StyledRepositoryItemStatusDots,
};
